function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".st0,.st1{fill:none;stroke:#3c00dc;stroke-linecap:round}.st0{stroke-miterlimit:10}.st1{stroke-linejoin:round}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M149 1.5L137.8 12c-.3.3-.3.8-.1 1.1l36 41.5c.3.3.8.4 1.1.1l13.6-11.4M66.1 13.7C73.3 11 84.2 9.3 94.5 17"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M44.4 20.9l-31.3 34L1.5 44.4M15.9 51.9c2.9 4.4 11.8 24.5 24 33.8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M52.4 82l2.4 2.4c2.4 2.4 2.4 6.3 0 8.8L51 96.8c-2.4 2.4-6.3 2.4-8.8 0l-2.4-2.4c-2.4-2.4-2.4-6.3 0-8.8l3.7-3.7c2.5-2.4 6.4-2.4 8.9.1zM97.9 103.9l1.6 1.6c2.6 2.6 2.6 6.9 0 9.6l-5.1 5.1c-2.6 2.6-6.9 2.6-9.6 0l-1.6-1.6c-2.6-2.6-2.6-6.9 0-9.6l5.1-5.1c2.7-2.6 7-2.6 9.6 0z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M70.4 86.1l2.4 2.4c2.4 2.4 2.4 6.3 0 8.8L62.1 108c-2.4 2.4-6.3 2.4-8.8 0l-2.4-2.4c-2.4-2.4-2.4-6.3 0-8.8l10.7-10.7c2.5-2.4 6.4-2.4 8.8 0z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M84.2 94.6l2.4 2.4c2.4 2.4 2.4 6.3 0 8.8l-13.4 13.4c-2.4 2.4-6.3 2.4-8.8 0l-2.4-2.4c-2.4-2.4-2.4-6.3 0-8.8l13.4-13.4c2.5-2.4 6.4-2.4 8.8 0zM124.1 81l14.3 14.2c3.4 3.4 3.4 8.9 0 12.3-3.4 3.4-8.9 3.4-12.3 0l-14.3-14.2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M110.4 91.8l14.2 14.2c3.4 3.4 3.4 8.9 0 12.3-3.4 3.4-8.9 3.4-12.3 0L98 104.1M95.9 118.7c3.1 3.1 9 7 16.4-.4"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M137.6 13c-11.9 3.4-15.1-1.5-25-1.9-11.3-.4-15.1 2.9-20.9 8.4-4 3.8-16 15.4-23.2 22.4-3.1 3-3.2 7.9-.3 11.1 3 3.2 8 3.4 11.2.4L95 39c1.9-1.8 4.9-1.7 6.8.1l46.3 46.3c.6.6 1.6.6 2.3 0 2.5-2.4 8.5-8.4 10.1-11.8 2.1-4.3 6.3-14.4 12.5-19.7"
});

function SvgHandshakeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 190 124",
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

export default SvgHandshakeinline;